import React, { useEffect } from "react";
import dayjs from "dayjs";

import { styled } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {
  TextMainTopic,
  TextTopic,
  TextData,
} from "../../../../shared/styledComponent";
require("dayjs/locale/th");
dayjs.locale("th");

const useStyles = makeStyles((theme) => ({
  Title: {
    fontSize: "30px",
  },
  typeAndModelDetail: {
    textAlign: "center",
  },
  GridPicture: {
    display: "flex",
    justifyContent: "center",
  },
  Avatar: {
    width: "350px",
    height: "200px",
    [theme.breakpoints.down("sm")]: {
      width: "250px",
      height: "150px",
    },
  },
  Dialog: {
    paddingBottom: "30px",
    "& .MuiPaper-root": {
      [theme.breakpoints.down("sm")]: {
        margin: "0",
      },
    },
  },
  DialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "blue",
    },
    [theme.breakpoints.down("sm")]: {
      height: "550px",
      overflowY: "auto",
      padding: "0",
    },
  },
  Grid: {
    width: "calc(100% - 50px)",
    marginLeft: "50px",
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 20px)",
      marginLeft: "0",
    },
  },
  Text: {
    fontSize: "23px",
    wordWrap: "break-word",
    color: "#525656",
    fontWeight: "500",
  },
  Icon: {
    marginTop: "3px",
    fontsize: "10px",
    marginRight: "3px",
  },
  Recipient: {
    color: "#525656",
    fontWeight: "500",
  },
  IconYellow: {
    color: "#DCA700",
  },
  GridTextIcon: {
    display: "flex",
  },
  Fixed: {
    backgroundColor: "#DCA700",
    "&:hover": {
      backgroundColor: "#ba8e04",
    },
  },
  Confirm: {
    backgroundColor: "green",
    "&:hover": {
      backgroundColor: "darkgreen",
    },
  },
  DialogActions: {
    paddingRight: "30px",
  },
  Button: {
    width: "150px",
    height: "50px",
  },
  TextButton: {
    color: "white",
  },
  IconWeight: {
    weight: "26px",
    height: "26px",
    marginRight: "3px",
  },
  IconImage: {
    weight: "30px",
    height: "30px",
    marginRight: "10px",
  },
}));

const GridContainText = styled(Grid)(({ theme }) => ({
  paddingRight: "24px",
  display: "flex",
}));

const DialogShowDetailBooking = (props) => {
  const classes = useStyles();
  return (
    <Dialog open={props.open} className={classes.Dialog} maxWidth="md">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "2rem",
          paddingBottom: "1rem",
        }}
      >
        <TextMainTopic>{props.topic}</TextMainTopic>
      </div>
      <DialogContent className={classes.DialogContent}>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Grid container spacing={3} className={classes.Grid}>
            {props.dataList.map((item, index) => (
              <GridContainText
                key={index}
                item
                xs={12}
                sm={6}
                lg={6}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <TextTopic>{item.label}</TextTopic>
                <TextData>&nbsp;&nbsp;{item.value}</TextData>
              </GridContainText>
            ))}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions className={classes.DialogActions}>
        <Button
          className={`${classes.Fixed} ${classes.Button}`}
          onClick={props.handleClose}
        >
          <Typography className={`${classes.Text} ${classes.TextButton}`}>
            แก้ไข
          </Typography>
        </Button>
        <Button
          className={`${classes.Confirm} ${classes.Button}`}
          onClick={props.onClickSubmit}
        >
          <Typography className={`${classes.Text} ${classes.TextButton}`}>
            ยืนยัน
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogShowDetailBooking;
